import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { loadUserAction } from '~/redux/actions/auth';
import { loadInvitationAction } from '~/redux/actions/invitation';
import { loadDietaryAction } from '~/redux/actions/dietary';
import {loadGuestsAction} from "~/redux/actions/guests";
import {loadLanguagesAction} from "~/redux/actions/translations";
import {loadTranslationsAction} from "~/redux/actions/translations";
import classnames from 'classnames';
import moment from 'moment-timezone';
import Moment from 'react-moment';
import { updateIsMobile } from './redux/actions/general';
import { debounce } from 'lodash';
import useEffectSkipFirst from './Hooks/useEffectSkipFirst';

const AppLoader = (props) => {

    useEffect(() => {
        props.dispatch(loadLanguagesAction());
        props.dispatch(loadTranslationsAction());

        // Dates will start from Monday instead of Sunday
        moment.locale('en', { week: { dow: 1 } });
        // Moment default/global timezone
        moment.tz.setDefault('Etc/UTC');
        // React moment global configuration
        Moment.globalMoment = moment;
        Moment.globalFormat = "MM DD YYYY";
        Moment.globalLocale = 'en';
        Moment.globalTimezone = 'Etc/UTC';
        Moment.globalLocal = true;
    }, []);

    useEffectSkipFirst(() => {
        props.dispatch(loadUserAction());
    }, [props.languages])

    useEffect(() => {
        if (props.user) {
            props.dispatch(loadDietaryAction());

            if (props.user.role.is_guest) {
                props.dispatch(loadInvitationAction());
            }
        }
    }, [props.user]);

    useEffectSkipFirst(() => {
        if (props.user) {
            if (props.user.role.is_guest) {
                props.dispatch(loadGuestsAction());
            }
        }
    }, [props.invitation]);

    useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            if( (window.innerWidth < 500 && props.isMobile === false) ||
                (window.innerWidth > 500 && props.isMobile === true)
            ) {
                props.dispatch(updateIsMobile());
            }
        }, 500);

        window.addEventListener('resize', debouncedHandleResize);

        return _ => {
            window.removeEventListener('resize', debouncedHandleResize);
        }
    });

    return (
        <Loader
            loadedClassName={classnames(["loaded-content mh-100 w-100", {
                bukra: props.currentLanguage.code === 'ar'
            }])}
            loaded={props.loaded}
        >
            <div dir={classnames({rtl: props.currentLanguage?.rtl})} className="page-wrapper d-flex flex-column flex-1">
                {props.children}
            </div>
        </Loader>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    user: state.auth?.user,
    isAuthenticated: state.auth?.isAuthenticated,
    loaded: state.auth?.loaded,
    invitation: state.invitation,
    languages: state.translations.languages,
    translations: state.translations.translations,
    isMobile: state.general.isMobile
});

export default connect(mapStateToProps)(AppLoader);
